import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import {
    FREE_CALL_PHONE_NUMBER_REGEX,
    HOME_PHONE_NUMBER_REGEX,
    MOBILE_PHONE_NUMBER_REGEX,
    OTHER_COUNTRY_PHONE_NUMBER_REGEX
} from '@classifieds-sell/shared';
import { Photo, SelectedPhotoData } from '@classifieds-sell/trademe-core-ui';
import {
    PropertyAgentContactChanges,
    PropertyAgentContactDetailsType
} from 'libs/property-ui/src/lib/models/property-agent-contact-details/property-agent-contact-details-model';

@Component({
    selector: 'property-agent-contact-detail',
    templateUrl: './property-agent-contact-detail.component.html',
    styleUrls: ['./property-agent-contact-detail.component.scss']
})
export class PropertyAgentContactDetailComponent {
    @Input() contactDetailType: PropertyAgentContactDetailsType;
    @Input() draftData: any;
    @Input() validation: any;
    @Input() phoneValidation: {landLine: any; mobile: any};
    @Input() hasErrorInContactDetails: boolean;
    photo!: Photo;

    @Output() contactDetailsChange = new EventEmitter<PropertyAgentContactChanges>();
    @Output() deleteContactDetails = new EventEmitter<void>();

    @ViewChild('agentContactDetailForm')
    agentContactDetailForm: NgForm;

    homePhoneNumberRegex = HOME_PHONE_NUMBER_REGEX;
    mobilePhoneNumberRegex = MOBILE_PHONE_NUMBER_REGEX;
    freeCallPhoneNumberRegex = FREE_CALL_PHONE_NUMBER_REGEX;
    otherCountryPhoneNumberRegex = OTHER_COUNTRY_PHONE_NUMBER_REGEX;

    get contactFieldKeys() {
        return this.contactDetailType === this.propertyAgentContactDetailsType.primary ? {
            name: 'name',
            mobile: 'mobile',
            landLine: 'landLine',
            email: 'email'
        } :
        {
            name: 'secondName',
            mobile: 'secondMobile',
            landLine: 'secondLandLine',
            email: 'secondEmail'
        };
    }

    get isPhotoRemovalDisabled() {
        const { propertyInformation } = this.draftData ?? {};
        const isPrimaryContact = this.contactDetailType === this.propertyAgentContactDetailsType.primary;

        return isPrimaryContact ? propertyInformation?.isPhotoRemovalDisabled : propertyInformation?.secondIsPhotoRemovalDisabled;
    }

    get agentPhoto() {
        const { brandingImageId, photoUrl, secondBrandingImageId, secondPhotoUrl} = this.draftData.propertyInformation;

        if (this.contactDetailType === this.propertyAgentContactDetailsType.primary && photoUrl !== null) {
            return {...this.photo, photoId: brandingImageId, plusSize: photoUrl};
        }
        if (this.contactDetailType === this.propertyAgentContactDetailsType.secondary && secondPhotoUrl !== null) {
            return { ...this.photo, photoId: secondBrandingImageId, plusSize: secondPhotoUrl };
        }
        return this.photo;
    }

    get propertyAgentContactDetailsType(): typeof PropertyAgentContactDetailsType {
        return PropertyAgentContactDetailsType;
    }

    onContactDetailsChange(selectedPhotoData: SelectedPhotoData = null, isRemoved = false) {
        this.contactDetailsChange.emit({type: this.contactDetailType, agentPhoto: selectedPhotoData, isRemoved});
    }

    onDeleteContactDetails() {
        this.deleteContactDetails.emit();
    }

    onPhotoSelected(selectedPhotoData: SelectedPhotoData) {
        this.onContactDetailsChange(selectedPhotoData);
    }

    onAgentPhotoRemoved(removedPhotoData: SelectedPhotoData) {
        this.onContactDetailsChange(removedPhotoData, true);
    }
}
